import React, { PureComponent } from 'react';
import { css } from '@emotion/css';

class DiscoAdsAppIconWrapper extends PureComponent {
  render() {
    const { url, title, styles } = this.props;
    const defaultIconStyle = css({
      height: '40px',
      width: '40px',
      borderRadius: '5px',
    });
    return (
      <div className={styles?.iconContainer ? styles.iconContainer : null}>
        <img className={styles?.icon ? styles.icon : defaultIconStyle} src={url} alt={title} />
      </div>
    );
  }
}

export default DiscoAdsAppIconWrapper;
